import React from "react";

import { getTranslatedLanguages } from "../../../utils/common";
import "./styles.scss";

interface ILanguagesWithTooltipProps {
  languages?: string[] | Set<string>;
  maxDisplay?: number;
  translateFn?: (lang: string) => string;
}

export const LanguagesWithTooltip: React.FC<ILanguagesWithTooltipProps> = ({
  languages,
  maxDisplay = 3,
  translateFn
}) => {
  if (!languages) return <>N/A</>;

  let translatedLangs: string;

  if (translateFn) {
    translatedLangs = Array.from(languages)
      .map((lang: string) => translateFn(lang))
      .join(", ");
  } else {
    const result = getTranslatedLanguages(new Set(languages));
    if (!result) return <>N/A</>;
    translatedLangs = result;
  }

  const langArray = translatedLangs.split(", ");

  if (langArray.length <= maxDisplay) {
    return <>{translatedLangs}</>;
  }

  const displayedLangs = langArray.slice(0, maxDisplay).join(", ");
  const remainingCount = langArray.length - maxDisplay;

  return (
    <>
      {displayedLangs}{" "}
      <span className="language-overflow" data-tooltip={translatedLangs}>
        +{remainingCount}
      </span>
    </>
  );
};
